import chromeExtensionVersion from './chromeExtensionVersion';

// Captured on import, before the router drops the parameter from the URL
const bootChromeExtensionVersion = chromeExtensionVersion();

export default bootChromeExtensionVersion;
